export default __webpack_public_path__ + "ce6f6e365413f2353162e43a3f31f0ee.png";